import { all, fork } from "redux-saga/effects";
import accountSaga from "./sagas/accountSaga";
import bankAccSaga from "./sagas/bankAccSaga";
import clientFailedSharesSaga from "./sagas/clientFailedSharesSaga";
import contributorSaga from "./sagas/contributorSaga";
import currencySaga from "./sagas/currencySaga";
import dashboardSaga from "./sagas/dashboardSaga";
import distributorSaga from "./sagas/distributorSaga";
import duesSaga from "./sagas/duesSaga";
import incomeShareSaga from "./sagas/incomeShareSaga";
import invoiceSaga from "./sagas/invoiceSaga";
import labelSaga from "./sagas/labelSaga";
import paymentSaga from "./sagas/paymentSaga";
import platformSaga from "./sagas/platformSaga";
import salesDataSaga from "./sagas/salesDataSaga";
import trackSaga from "./sagas/trackSaga";
import userSaga from "./sagas/userSaga";

export default function* rootSaga() {
  yield all([
    fork(accountSaga),
    fork(bankAccSaga),
    fork(clientFailedSharesSaga),
    fork(contributorSaga),
    fork(currencySaga),
    fork(incomeShareSaga),
    fork(duesSaga),
    fork(labelSaga),
    fork(platformSaga),
    fork(distributorSaga),
    fork(salesDataSaga),
    fork(trackSaga),
    fork(paymentSaga),
    fork(invoiceSaga),
    fork(userSaga),
    fork(dashboardSaga),
  ]);
}
